import { styled } from 'styled-components';

export const Button = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--grey-dark-color) !important;
    padding: 0.5rem 1rem !important;
    border-radius: 0.5rem;
    max-width: 10rem;
    width: 100%;
    border: none;
    outline: none;
    cursor: pointer;
   
`;